import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function BibleVersionPicker() {
  const { user, setUser } = useAuth();
  const [versions, setVersions] = useState<any[]>([]);
  const current = user.bible_version || "kjv";
  useEffect(() => { api.get("/bible/versions").then((r) => setVersions(r.data.versions)).catch(() => {}); }, []);
  const choose = async (id: string) => {
    try { await api.put("/me/bible-version", { version: id }); setUser({ ...user, bible_version: id }); toast.success("Bible version saved"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section className="card-warm p-6 sm:p-8" data-testid="bible-version-picker">
      <p className="eyebrow">Bible version</p>
      <p className="mt-1 text-sm text-slate-500">Used for every verse in Cast: stories, study, the verse of the day and the study helper.{user.role === "parent" ? " Your children's stories use it too." : ""}</p>
      <div className="mt-4 grid gap-3 sm:grid-cols-2">
        {versions.map((v) => {
          const active = current === v.id;
          return (
            <button key={v.id} data-testid={`bible-version-${v.id}`} onClick={() => !active && choose(v.id)} aria-pressed={active}
              className={`flex items-start gap-3 rounded-2xl border p-4 text-left transition-colors ${active ? "border-[#C86D51] bg-[#FBF3EC]" : "border-[#E2DBCE] bg-white hover:bg-[#FAF7F2]"}`}>
              <span className={`mt-0.5 flex h-9 w-12 shrink-0 items-center justify-center rounded-lg text-xs font-bold ${active ? "bg-[#C86D51] text-white" : "bg-[#F3ECE0] text-slate-700"}`}>{v.abbr}</span>
              <span className="min-w-0 flex-1"><span className="block font-semibold text-slate-900">{v.name}</span><span className="block text-xs text-slate-500">{v.note}</span></span>
              {active && <Check className="h-4 w-4 shrink-0 text-[#C86D51]" data-testid={`bible-version-active-${v.id}`} />}
            </button>
          );
        })}
      </div>
    </section>
  );
}
